import React from 'react';
import { X } from 'lucide-react';

export default function FilterChips({ filters, onRemove, onClearAll }) {
  const entries = Object.entries(filters).filter(([, v]) => v);
  if (entries.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 py-2">
      {entries.map(([key, value]) => (
        <span
          key={key}
          className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-primary/10 text-primary border border-primary/20"
        >
          <span className="text-muted-foreground mr-0.5">{key}:</span>
          {value}
          <button onClick={() => onRemove(key)} className="ml-0.5 hover:text-destructive transition-colors">
            <X className="w-3 h-3" />
          </button>
        </span>
      ))}
      {entries.length > 1 && (
        <button
          onClick={onClearAll}
          className="text-xs text-muted-foreground hover:text-foreground underline underline-offset-2"
        >
          Clear all
        </button>
      )}
    </div>
  );
}